import { getActiveTheme } from "./themeSystem"

export function buildTokens(activeTheme = getActiveTheme()) {
  const theme = activeTheme || getActiveTheme()

  return {
    fontFamily:
      'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',

    color: {
      appBg: theme.colors.bgPage,
      surface: theme.colors.bgCard,
      surfaceAlt: theme.colors.bgSoft,
      surfaceSoft: "#EEF3F9",

      border: theme.colors.border,
      borderStrong: theme.colors.borderStrong,

      text: theme.colors.text,
      textSoft: theme.colors.textSoft,
      textMuted: theme.colors.textMuted,

      brand600: theme.colors.primaryDark,
      brand500: theme.colors.primary,
      brand400: theme.colors.accent,

      violet500: theme.colors.violet || "#7C3AED",

      successBg: theme.colors.successBg,
      successBorder: theme.colors.successBorder,
      successText: theme.colors.success,

      warningBg: theme.colors.warningBg,
      warningBorder: theme.colors.warningBorder,
      warningText: theme.colors.warning,

      dangerBg: theme.colors.dangerBg,
      dangerBorder: theme.colors.dangerBorder,
      dangerText: theme.colors.danger,

      infoBg: theme.colors.infoBg,
      infoBorder: theme.colors.infoBorder,
      infoText: theme.colors.info
    },

    radius: {
      xs: 8,
      sm: 10,
      md: 14,
      lg: 18,
      xl: 22,
      pill: 999
    },

    shadow: {
      subtle: "0 4px 12px rgba(15, 23, 42, 0.03)",
      soft: "0 6px 16px rgba(15, 23, 42, 0.04)",
      card: "0 10px 24px rgba(15, 23, 42, 0.05)",
      raised: "0 14px 28px rgba(15, 23, 42, 0.08)",
      hero: "0 18px 40px rgba(15, 23, 42, 0.14)",
      focus: "0 0 0 3px rgba(36, 87, 214, 0.14)"
    },

    spacing: {
      xxs: 4,
      xs: 6,
      sm: 8,
      md: 12,
      lg: 16,
      xl: 20,
      "2xl": 24,
      "3xl": 32
    },

    controlHeight: {
      sm: 34,
      md: 40,
      lg: 46,
      xl: 52
    },

    type: {
      overline: {
        fontSize: 10,
        fontWeight: 900,
        lineHeight: 1.2
      },
      hero: {
        fontSize: 28,
        fontWeight: 900,
        lineHeight: 1.02
      },
      page: {
        fontSize: 24,
        fontWeight: 900,
        lineHeight: 1.06
      },
      section: {
        fontSize: 16,
        fontWeight: 900,
        lineHeight: 1.15
      },
      card: {
        fontSize: 14,
        fontWeight: 800,
        lineHeight: 1.2
      },
      body: {
        fontSize: 13,
        fontWeight: 500,
        lineHeight: 1.5
      },
      meta: {
        fontSize: 11,
        fontWeight: 700,
        lineHeight: 1.35
      },
      metric: {
        fontSize: 30,
        fontWeight: 900,
        lineHeight: 1
      }
    },

    gradient: {
      hero: theme.gradients.hero,
      heroSoft: theme.gradients.heroSoft,
      sidebar: theme.gradients.sidebar,
      cta: theme.gradients.cta
    },

    layout: {
      sidebarWidth: 252,
      sidebarCompactWidth: 88,
      topbarHeight: 74,
      contentMaxWidth: 1680
    }
  }
}

export const tokens = buildTokens()